// src/utils/sticker/sticker-load.ts
// Maps a loaded entry's stored sticker fields back to the image-aligned shape the
// UI and the background generation effect expect.
//
// Stickers are stored DENSELY (only the non-null ones, in image order). On load we
// re-expand them to an array index-aligned with `images`, using `imageStickerable`
// (true exactly where a sticker exists) as the cursor guide.
//
// CRITICAL: `imageStickerable` is passed through VERBATIM. When an entry has never
// been sticker-processed it is `undefined`, and that `undefined` MUST be preserved —
// the background generation effect triggers on `imageStickerable === undefined`, and
// the "Making sticker…" pending UI distinguishes "not processed yet" (undefined) from
// "processed" (a defined array). Coercing `undefined` to `[]` here wedges the entry:
// it never gets processed yet shows "Making sticker…" forever.

export interface LoadedStickerFields {
  stickerImages: (string | null)[];
  imageStickerable: boolean[] | undefined;
  imageDisplayModes: ('normal' | 'sticker')[] | undefined;
}

export function mapLoadedStickers(
  images: string[] | undefined,
  denseStickers: (string | null)[] | undefined,
  imageStickerable: boolean[] | undefined,
  imageDisplayModes: ('normal' | 'sticker')[] | undefined,
): LoadedStickerFields {
  const flags = imageStickerable ?? [];
  const dense = denseStickers ?? [];
  let k = 0;
  const stickerImages = (images ?? []).map((_, i) =>
    flags[i] ? (dense[k++] ?? null) : null,
  );
  return { stickerImages, imageStickerable, imageDisplayModes };
}
